/**
* 工作台
*/
<template>
  <!-- 组件主盒子 -->
  <div class="stbox">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>工作台</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索，切换 -->
    <!--    <el-row :gutter="23" style="margin-bottom: 20px">
      <el-col :span="18">
        <div class="stbgc">
          <el-row :gutter="23">
            <el-col :span="7">
              <div class="flexItem">
                <span style="width: 120px">订单编号:</span
                ><el-input
                  size="small"
                  v-model="queryData.orderNum"
                  placeholder="请输入订单编号"
                ></el-input>
              </div>
            </el-col>
            <el-col :span="7">
              <div class="flexItem">
                <span style="width: 120px">用户名称:</span
                ><el-input
                  size="small"
                  v-model="queryData.userName"
                  placeholder="请输入用户名称"
                ></el-input>
              </div>
            </el-col>
            <el-col :span="7">
              <div class="flexItem">
                <span style="width: 120px">套餐查询:</span>
                <el-select
                  v-model="queryData.taoCan"
                  size="small"
                  style="width: 100%"
                  placeholder="请选择套餐"
                >
                  <el-option
                    v-for="item in listData"
                    :key="item.id"
                    :label="item.title"
                    align="center"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </div>
            </el-col>
            <el-col :span="3" class="stsearch">
              <el-button size="small" type="primary" @click="toOrder"
                >搜索</el-button
              >
            </el-col>
          </el-row>
        </div>
      </el-col>
    </el-row> -->
    <!-- 统计图1 -->
    <!--    <el-row :gutter="23">
      <el-col :span="12" class="text-c">
        <div
          style="
            display: flex;
            justify-content: space-between;
            padding: 30px 30px 0 30px;
            box-sizing: border-box;
            background-color: #fff;
          "
        >
          <div
            style="
              border-left: 5px solid #3bcbff;
              line-height: 33px;
              padding-left: 10px;
              font-size: 18px;
            "
          >
            新增用户数量
          </div>
          <div style="line-height: 28px; padding-left: 10px; font-size: 16px">
            <span style="font-size: 30px; color: #54acf7">{{
              createTime1Count
            }}</span>
            人
          </div>
          <div>
            <el-select
              v-model="selectData.createTime1"
              class="selectClass"
              size="mini"
              placeholder="请选择"
              @change="selectChange('createTime1', $event)"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                align="center"
                :value="item.value"
              >
              </el-option>
              <div style="text-align: center; margin: 10px 0">
                <el-date-picker
                  v-model="dateData.createTime1"
                  type="daterange"
                  ref="createTime1"
                  range-separator="至"
                  clearable
                  @change="timeChange('createTime1', $event)"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                >
                </el-date-picker>
              </div>
            </el-select>
          </div>
        </div>
        <div class="st-gbox">
          <div class="cavasbox" ref="SCEchart"></div>
        </div>
      </el-col>
      <el-col :span="12" class="text-c">
        <div
          style="
            display: flex;
            justify-content: space-between;
            padding: 30px 30px 0 30px;
            box-sizing: border-box;
            background-color: #fff;
          "
        >
          <div
            style="
              border-left: 5px solid #3bcbff;
              line-height: 33px;
              padding-left: 10px;
              font-size: 18px;
            "
          >
            新增订单数量
          </div>
          <div style="line-height: 28px; padding-left: 10px; font-size: 16px">
            <span style="font-size: 30px; color: #54acf7">{{
              createTime2Count
            }}</span>
            单
          </div>
          <div>
            <el-select
              v-model="selectData.createTime2"
              class="selectClass"
              size="mini"
              placeholder="请选择"
              @change="selectChange('createTime2', $event)"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                align="center"
                :value="item.value"
              >
              </el-option>
              <div style="text-align: center; margin: 10px 0">
                <el-date-picker
                  v-model="dateData.createTime2"
                  type="daterange"
                  ref="createTime2"
                  range-separator="至"
                  clearable
                  @change="timeChange('createTime2', $event)"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                >
                </el-date-picker>
              </div>
            </el-select>
          </div>
        </div>
        <div class="st-gbox">
          <div class="cavasbox" ref="ClickEchart"></div>
        </div>
      </el-col>
    </el-row> -->
    <!-- 统计图2 -->
    <div style="margin-top: 20px">
      <el-row :gutter="23">
        <el-col :span="12" class="text-c">
          <div style="
              display: flex;
              justify-content: space-between;
              padding: 30px 30px 0 30px;
              box-sizing: border-box;
              background-color: #fff;
            ">
            <div style="
                border-left: 5px solid #3bcbff;
                line-height: 33px;
                padding-left: 10px;
                font-size: 18px;
              ">
              近30天订单
            </div>
            <div style="line-height: 28px; padding-left: 10px; font-size: 16px">
              <span style="font-size: 30px; color: #54acf7">{{
                totalAmount
              }}</span>
              元
            </div>
            <!-- <div>
              <el-select
                v-model="selectData.createTime4"
                class="selectClass"
                size="mini"
                placeholder="请选择"
                @change="selectChange('createTime4', $event)"
              >
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  align="center"
                  :value="item.value"
                >
                </el-option>
                <div style="text-align: center; margin: 10px 0">
                  <el-date-picker
                    v-model="dateData.createTime4"
                    type="daterange"
                    ref="createTime4"
                    range-separator="至"
                    clearable
                    @change="timeChange('createTime4', $event)"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  >
                  </el-date-picker>
                </div>
              </el-select>
            </div> -->
          </div>
          <div class="st-gbox">
            <div class="cavasbox" ref="SUMEchart"></div>
          </div>
        </el-col>

        <el-col :span="12" class="text-c">
          <div style="
              display: flex;
              justify-content: space-between;
              padding: 30px 30px 0 30px;
              box-sizing: border-box;
              background-color: #fff;
            ">
            <div style="
                border-left: 5px solid #3bcbff;
                line-height: 33px;
                padding-left: 10px;
                font-size: 18px;
              ">
              退款订单
            </div>
            <div style="line-height: 28px; padding-left: 10px; font-size: 16px">
              <span style="font-size: 30px; color: #54acf7">{{
                refundTotalAmount
              }}</span>
              元
            </div>
            <!-- <div>
              <el-select v-model="selectData.createTime3" class="selectClass" size="mini" placeholder="请选择"
                @change="selectChange('createTime3', $event)">
                <el-option v-for="item in options" :key="item.value" :label="item.label" align="center"
                  :value="item.value">
                </el-option>
                <div style="text-align: center; margin: 10px 0">
                  <el-date-picker v-model="dateData.createTime3" type="daterange" ref="createTime3" range-separator="至"
                    clearable @change="timeChange('createTime3', $event)" start-placeholder="开始日期"
                    end-placeholder="结束日期">
                  </el-date-picker>
                </div>
              </el-select>
            </div> -->
          </div>
          <div class="paybox">
            <div class="cavasbox" ref="payEchart"></div>
          </div>
        </el-col>
        <!-- <el-col :span="12" class="text-c">
          <div class="paybox">
            <div class="cavasbox" ref="payNumEchart"></div>
          </div>
        </el-col> -->
      </el-row>
    </div>
    <div style="margin-top: 20px">
      <el-row :gutter="23">
        <el-col :span="12" class="text-c">
          <div style="
              display: flex;
              justify-content: space-between;
              padding: 30px 30px 0 30px;
              box-sizing: border-box;
              background-color: #fff;
            ">
            <div style="
                border-left: 5px solid #3bcbff;
                line-height: 33px;
                padding-left: 10px;
                font-size: 18px;
              ">
              香港扫码付
            </div>
            <div style="line-height: 28px; padding-left: 10px; font-size: 16px">
              <span style="font-size: 30px; color: #54acf7">{{
                hkQrTotalAmount
              }}</span>
              元
            </div>
          </div>
          <div class="paybox">
            <div class="cavasbox" ref="showEchart"></div>
          </div>
        </el-col>

          <el-col :span="12" class="text-c">
            <div style="
                display: flex;
                justify-content: space-between;
                padding: 30px 30px 0 30px;
                box-sizing: border-box;
                background-color: #fff;
              ">
              <div style="
                  border-left: 5px solid #3bcbff;
                  line-height: 33px;
                  padding-left: 10px;
                  font-size: 18px;
                ">
                香港支付
              </div>
              <div style="line-height: 28px; padding-left: 10px; font-size: 16px">
                <span style="font-size: 30px; color: #54acf7">{{
                  hkTotalAmount
                }}</span>
                元
              </div>
            </div>
            <div class="paybox">
              <div class="cavasbox" ref="showHKEchart"></div>
            </div>
          </el-col>
      </el-row>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
  import {
    regUserReport,
    vipTypeReport,
    userPayOrderReport,
    userRefundOrderReport,
    vpnVipPage,
    vipTypePhoneReport,
  } from "../../api/payMG";
  import Chart from "echarts";
  export default {
    name: "welcome",
    data() {
      return {
        queryData: {
          orderNum: null,
          userName: null,
          taoCan: null,
        },
        machineNo: "",
        type: "day",
        selectData: {
          createTime1: "0",
          createTime2: "0",
          createTime3: "0",
          createTime4: "0",
        },
        dateData: {
          createTime1: this.getCurrentDay(),
          createTime2: this.getCurrentDay(),
          createTime3: this.getCurrentDay(),
          createTime4: this.getCurrentDay(),
        },
        options: [{
            value: "0",
            label: "当天",
          },
          {
            value: "1",
            label: "本周",
          },
          {
            value: "2",
            label: "本月",
          },
          {
            value: "3",
            label: "半年",
          },
          {
            value: "4",
            label: "一年",
          },
          {
            value: "5",
            label: "自定义",
          },
        ],
        //  销售总笔数
        SCEoption: {
          tooltip: {
            trigger: "item",
            formatter: "{b} <br/>{a} : {c}",
          },
          grid: {
            left: 50,
            right: 10,
            top: 30,
            bottom: 30,
            borderWidth: 1,
          },
          xAxis: {
            type: "category",
            data: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"],
            axisLine: {
              lineStyle: {
                color: "#999999",
                width: 1,
              },
            },
            axisLabel: {
              margin: 14,
              height: 170,
              interval: "auto",
              textStyle: {
                fontSize: 10,
                color: "#999999",
              },
            },
          },
          yAxis: {
            type: "value",
            axisLine: {
              lineStyle: {
                color: "#999999",
                width: 1,
              },
            },
            axisLabel: {
              margin: 14,
              textStyle: {
                fontSize: 10,
                color: "#999999",
              },
            },
          },
          series: [{
            name: "新增用户数量",
            type: "bar",
            barGap: 0,
            data: [
              50000, 70000, 80000, 40000, 50000, 30000, 40000, 60000, 50000,
              40000, 60000, 40000,
            ],
            barWidth: 10,
            itemStyle: {
              normal: {
                color: new Chart.graphic.LinearGradient(0, 0, 0, 1, [{
                    offset: 0,
                    color: "#409EFF"
                  },
                  {
                    offset: 0.5,
                    color: "#409EFF"
                  },
                  {
                    offset: 1,
                    color: "#409EFF"
                  },
                ]),
              },
              emphasis: {
                color: new Chart.graphic.LinearGradient(0, 0, 0, 1, [{
                    offset: 0,
                    color: "#2378f7"
                  },
                  {
                    offset: 0.7,
                    color: "#2378f7"
                  },
                  {
                    offset: 1,
                    color: "#2378f7"
                  },
                ]),
              },
            },
          }, ],
        },
        createTime1X: [],
        createTime1Y: [],
        //  销售总金额
        SUMoption: {
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "cross",
            },
            formatter: "{b} <br/>{a} : {c}",
            padding: [5, 10],
          },
          xAxis: {
            data: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"],
            boundaryGap: false,
            axisTick: {
              show: false,
            },
            axisLabel: {
              margin: 14,
              height: 170,
              interval: "auto",
              textStyle: {
                fontSize: 10,
                color: "#999999",
              },
            },
          },
          grid: {
            left: 10,
            right: 10,
            bottom: 20,
            top: 30,
            containLabel: true,
          },
          yAxis: {
            axisTick: {
              show: false,
            },
          },
          series: [{
            name: "订单总金额",
            itemStyle: {
              normal: {
                color: "#8A8CFF",
                lineStyle: {
                  color: "#8A8CFF",
                  width: 2,
                },
              },
            },
            smooth: true,
            type: "line",
            areaStyle: {
              // 要加这个属性,折线与下方的区域才能填充颜色
              color: {
                // 这边是设置渐变色,好看一点
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [{
                    offset: 0,
                    color: "rgba(138, 140, 255, .5)",
                  },
                  {
                    offset: 1,
                    color: "rgba(138, 140, 255, 0)",
                  },
                ],
                global: false,
              },
            },
            data: [
              50000, 70000, 80000, 40000, 50000, 30000, 40000, 60000, 50000,
              40000, 60000, 40000,
            ],
            animationDuration: 2000,
            animationEasing: "cubicInOut",
          }, ],
        },
        createTime4X: [],
        createTime4Y: [],

        //  总点击量
        Clickoption: {
          tooltip: {
            trigger: "item",
            formatter: "{b} <br/>{a} : {c}",
          },
          grid: {
            left: 50,
            right: 10,
            top: 30,
            bottom: 30,
            borderWidth: 1,
          },
          xAxis: {
            type: "category",
            data: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"],
            axisLine: {
              lineStyle: {
                color: "#999999",
                width: 1,
              },
            },
            axisLabel: {
              margin: 14,
              height: 70,
              interval: "auto",
              textStyle: {
                fontSize: 10,
                color: "#999999",
              },
            },
          },
          yAxis: {
            type: "value",
            axisLine: {
              lineStyle: {
                color: "#999999",
                width: 1,
              },
            },
            axisLabel: {
              margin: 14,
              textStyle: {
                fontSize: 10,
                color: "#999999",
              },
            },
          },
          series: [{
            name: "新增订单数量",
            type: "bar",
            barGap: 0,
            data: [
              50000, 10000, 80000, 30000, 50000, 60000, 40000, 80000, 50000,
              20000, 60000, 40000,
            ],
            barWidth: 10,
            itemStyle: {
              color: "#48cefd",
            },
          }, ],
        },
        createTime2X: [],
        createTime2Y: [],
        //  支付方式统计
        colorList: ["#FF5894", "#3DC8E3", "#8A8CFF", "#409EFF", "#abc", "ffaabb"],
        // payoption: {
        //   backgroundColor: "#fff",

        //   tooltip: {
        //     trigger: "item",
        //     formatter: "{b} <br/>{a} : {c} 单",
        //   },
        //   legend: {
        //     orient: "horizontal", // 图例列表的布局朝向，'horizontal'为水平,'vertical'为垂直
        //     x: "center", // 图例的位置
        //     y: "bottom", // 图例的位置
        //     data: ["1小时", "1个月", "3个月", "12个月"],
        //   },
        //   // visualMap: {
        //   //   show: false,
        //   //   min: 80,
        //   //   max: 600,
        //   //   inRange: {
        //   //     colorLightness: [0, 1]
        //   //   }
        //   // },
        //   series: [{
        //     name: "已付费套餐",
        //     type: "pie",
        //     radius: "55%",
        //     center: ["50%", "40%"],
        //     data: [{
        //         value: 100,
        //         name: "1小时",
        //         itemStyle: {
        //           color: "#FF5894"
        //         }
        //       },
        //       {
        //         value: 230,
        //         name: "1个月",
        //         itemStyle: {
        //           color: "#3DC8E3"
        //         }
        //       },
        //       {
        //         value: 384,
        //         name: "3个月",
        //         itemStyle: {
        //           color: "#8A8CFF"
        //         }
        //       },
        //       {
        //         value: 575,
        //         name: "12个月",
        //         itemStyle: {
        //           color: "#409EFF"
        //         }
        //       },
        //     ].sort(function(a, b) {
        //       return a.value - b.value;
        //     }),
        //     // roseType: 'radius',
        //     // label: {
        //     //   normal: {
        //     //     textStyle: {
        //     //       color: '#333'
        //     //     }
        //     //   },
        //     //   formatter: '{b}: {c} ({d}%)' // 标签文本格式器，此处 {b} 表示数据名，{c} 表示数据值，{d} 表示百分比
        //     // },

        //     label: {
        //       show: true, // 显示标签
        //       position: "outside", // 标签显示的位置，'outside' 表示标签在扇区外侧
        //       formatter: "{c} 单", // 标签文本格式器，此处 {b} 表示数据名，{c} 表示数据值，{d} 表示百分比
        //       textStyle: {
        //         color: "#333",
        //       },
        //     },
        //     labelLine: {
        //       normal: {
        //         lineStyle: {
        //           color: "#33333399",
        //         },
        //         smooth: 0.2,
        //         length: 10,
        //         length2: 20,
        //       },
        //     },
        //     animationType: "scale",
        //     animationEasing: "elasticOut",
        //     animationDelay: function(idx) {
        //       return Math.random() * 200;
        //     },
        //   }, ],
        // },

        payoption: {
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "cross",
            },
            formatter: "{b} <br/>{a} : {c}",
            padding: [5, 10],
          },
          xAxis: {
            data: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"],
            boundaryGap: false,
            axisTick: {
              show: false,
            },
            axisLabel: {
              margin: 14,
              height: 170,
              interval: "auto",
              textStyle: {
                fontSize: 10,
                color: "#999999",
              },
            },
          },
          grid: {
            left: 10,
            right: 10,
            bottom: 20,
            top: 30,
            containLabel: true,
          },
          yAxis: {
            axisTick: {
              show: false,
            },
          },
          series: [{
            name: "订单总金额",
            itemStyle: {
              normal: {
                color: "#8A8CFF",
                lineStyle: {
                  color: "#8A8CFF",
                  width: 2,
                },
              },
            },
            smooth: true,
            type: "line",
            areaStyle: {
              // 要加这个属性,折线与下方的区域才能填充颜色
              color: {
                // 这边是设置渐变色,好看一点
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [{
                    offset: 0,
                    color: "rgba(138, 140, 255, .5)",
                  },
                  {
                    offset: 1,
                    color: "rgba(138, 140, 255, 0)",
                  },
                ],
                global: false,
              },
            },
            data: [
              50000, 70000, 80000, 40000, 50000, 30000, 40000, 60000, 50000,
              40000, 60000, 40000,
            ],
            animationDuration: 2000,
            animationEasing: "cubicInOut",
          }, ],
        },
        createTime3X: [],
        createTime3Y: [],




        createTime1Count: null,
        createTime2Count: null,
        createTime3Count: null,
        totalAmount: null,
        refundTotalAmount: null,
        hkQrTotalAmount: null,
        hkTotalAmount: null,
        createTime5Count: null,
        listData: [],
        showListData: [],
        showUseoption: {
          backgroundColor: "#fff",
          tooltip: {
            trigger: "item",
            formatter: "{b} <br/>{a} : {c} 台",
          },
          legend: {
            orient: "horizontal", // 图例列表的布局朝向，'horizontal'为水平,'vertical'为垂直
            x: "center", // 图例的位置
            y: "bottom", // 图例的位置
            data: ["1小时", "1个月", "3个月", "12个月"],
          },
          // visualMap: {
          //   show: false,
          //   min: 80,
          //   max: 600,
          //   inRange: {
          //     colorLightness: [0, 1]
          //   }
          // },
          series: [{
            name: "正在使用",
            type: "pie",
            radius: "55%",
            center: ["50%", "50%"],
            data: [{
                value: 100,
                name: "1小时",
                itemStyle: {
                  color: "#FF5894"
                }
              },
              {
                value: 230,
                name: "1个月",
                itemStyle: {
                  color: "#3DC8E3"
                }
              },
              {
                value: 384,
                name: "3个月",
                itemStyle: {
                  color: "#8A8CFF"
                }
              },
              {
                value: 575,
                name: "12个月",
                itemStyle: {
                  color: "#409EFF"
                }
              },
            ].sort(function(a, b) {
              return a.value - b.value;
            }),
            // roseType: 'radius',
            // label: {
            //   normal: {
            //     textStyle: {
            //       color: '#333'
            //     }
            //   },
            //   formatter: '{b}: {c} ({d}%)' // 标签文本格式器，此处 {b} 表示数据名，{c} 表示数据值，{d} 表示百分比
            // },

            label: {
              show: true, // 显示标签
              position: "outside", // 标签显示的位置，'outside' 表示标签在扇区外侧
              formatter: "{c} 台", // 标签文本格式器，此处 {b} 表示数据名，{c} 表示数据值，{d} 表示百分比
              textStyle: {
                color: "#333",
              },
            },
            labelLine: {
              normal: {
                lineStyle: {
                  color: "#33333399",
                },
                smooth: 0.2,
                length: 10,
                length2: 20,
              },
            },
            animationType: "scale",
            animationEasing: "elasticOut",
            animationDelay: function(idx) {
              return Math.random() * 200;
            },
          }, ],
        },
      };
    },
    // 导入组件
    components: {
      // 点聚合组件
    },
    // 创建完毕状态(里面是操作)
    created() {

    },
    // 挂载结束状态(里面是操作)
    mounted() {
      // this.selectChange("createTime1", "0");
      // this.selectChange("createTime2", "0");
      // this.selectChange("createTime3", "0");
      // // this.selectChange("createTime4", "0");
      // console.log('this.createTime1X', this.createTime1X)
      // this.SCEoption.xAxis.data = this.createTime1X;
      // console.log('this.createTime1X', this.createTime1X)
      // this.getSCE();
      // this.Clickoption.xAxis.data = this.createTime2X;
      // this.getClick();
      // this.payoption.xAxis.data = this.createTime3X
      this.getpay();
      // this.SUMoption.xAxis.data = this.createTime4X;
      this.getSUM();
      // this.getVipTypePhoneReport();
    },
    // 里面的函数只有调用才会执行
    methods: {
      intervalDays(startDate, endDate) {
        const start = new Date(startDate);
        const end = new Date(endDate);
        return Math.ceil(Math.abs(end - start) / (1000 * 60 * 60 * 24));
      },
      dateRange(begin, end) {
        let arr1 = begin.split("-");
        let arr2 = end.split("-");
        let arr1_ = new Date();
        let arrTime = [];
        arr1_.setUTCFullYear(arr1[0], arr1[1] - 1, arr1[2]);
        let arr2_ = new Date();
        arr2_.setUTCFullYear(arr2[0], arr2[1] - 1, arr2[2]);
        let unixDb = arr1_.getTime();
        let unixDe = arr2_.getTime();
        for (let k = unixDb; k <= unixDe;) {
          arrTime.push(this.datetimeparse(k, "YYYY-MM-DD"));
          k = k + 24 * 60 * 60 * 1000;
        }
        return arrTime;
      },
      dateRangeM(begin, end) {
        let arr1 = begin.split("-");
        let arr2 = end.split("-");
        let arr1_ = new Date();
        let arrTime = [];
        arr1_.setUTCFullYear(arr1[0], arr1[1] - 1, arr1[2]);
        let arr2_ = new Date();
        arr2_.setUTCFullYear(arr2[0], arr2[1] - 1, arr2[2]);
        let unixDb = arr1_.getTime();
        let unixDe = arr2_.getTime();
        for (let k = unixDb; k <= unixDe;) {
          arrTime.push(this.datetimeparse(k, "YYYY-MM"));
          k = k + 24 * 60 * 60 * 1000;
        }
        return arrTime;
      },
      dateRangeY(begin, end) {
        let arr1 = begin.split("-");
        let arr2 = end.split("-");
        let arr1_ = new Date();
        let arrTime = [];
        arr1_.setUTCFullYear(arr1[0], arr1[1] - 1, arr1[2]);
        let arr2_ = new Date();
        arr2_.setUTCFullYear(arr2[0], arr2[1] - 1, arr2[2]);
        let unixDb = arr1_.getTime();
        let unixDe = arr2_.getTime();
        for (let k = unixDb; k <= unixDe;) {
          arrTime.push(this.datetimeparse(k, "YYYY"));
          k = k + 24 * 60 * 60 * 1000;
        }
        return arrTime;
      },
      // 时间格式处理
      datetimeparse(timestamp, format, prefix) {
        if (typeof timestamp == "string") {
          timestamp = Number(timestamp);
        }
        //转换时区
        let currentZoneTime = new Date(timestamp);
        let currentTimestamp = currentZoneTime.getTime();
        let offsetZone = currentZoneTime.getTimezoneOffset() / 60; //如果offsetZone>0是西区，西区晚
        let offset = null;
        //客户端时间与服务器时间保持一致，固定北京时间东八区。
        offset = offsetZone + 8;
        currentTimestamp = currentTimestamp + offset * 3600 * 1000;

        let newtimestamp = null;
        if (currentTimestamp) {
          if (currentTimestamp.toString().length === 13) {
            newtimestamp = currentTimestamp.toString();
          } else if (currentTimestamp.toString().length === 10) {
            newtimestamp = currentTimestamp + "000";
          } else {
            newtimestamp = null;
          }
        } else {
          newtimestamp = null;
        }
        let dateobj = newtimestamp ?
          new Date(parseInt(newtimestamp)) :
          new Date();
        let YYYY = dateobj.getFullYear();
        let MM =
          dateobj.getMonth() > 8 ?
          dateobj.getMonth() + 1 :
          "0" + (dateobj.getMonth() + 1);
        let DD =
          dateobj.getDate() > 9 ? dateobj.getDate() : "0" + dateobj.getDate();
        let HH =
          dateobj.getHours() > 9 ? dateobj.getHours() : "0" + dateobj.getHours();
        let mm =
          dateobj.getMinutes() > 9 ?
          dateobj.getMinutes() :
          "0" + dateobj.getMinutes();
        let ss =
          dateobj.getSeconds() > 9 ?
          dateobj.getSeconds() :
          "0" + dateobj.getSeconds();
        let output = "";
        let separator = "/";
        if (format) {
          separator = format.match(/-/) ? "-" : "/";
          output += format.match(/yy/i) ? YYYY : "";
          output += format.match(/MM/) ?
            (output.length ? separator : "") + MM :
            "";
          output += format.match(/dd/i) ?
            (output.length ? separator : "") + DD :
            "";
          output += format.match(/hh/i) ? (output.length ? " " : "") + HH : "";
          output += format.match(/mm/) ? (output.length ? ":" : "") + mm : "";
          output += format.match(/ss/i) ? (output.length ? ":" : "") + ss : "";
        } else {
          output += YYYY + separator + MM + separator + DD;
        }
        output = prefix ? prefix + output : output;

        return newtimestamp ? output : "";
      },
      toOrder() {
        this.$router.push({
          path: "/pay/Order",
          query: this.queryData
        });
      },
      getCurrentDay() {
        const now = new Date(); // 获取当前日期和时间
        // 使用 toLocaleDateString 获取本地日期字符串，默认格式通常是 YYYY/MM/DD
        let currentDate = now.toLocaleDateString();
        let dataList = [];
        // 格式化日期，确保月份和日期是两位数的格式
        let arr = currentDate.split("/");
        if (arr.length === 3) {
          // 确保日期数组有三部分
          if (arr[0].length < 4) {
            // 年份通常为4位，如果不是，则假定为月份或日期
            // 假设是月份，交换第一个和第二个元素的位置
            [arr[0], arr[1]] = [arr[1], arr[0]];
          }
          if (parseInt(arr[1]) < 10) {
            arr[1] = "0" + arr[1]; // 月份补0
          }
          if (parseInt(arr[2]) < 10) {
            arr[2] = "0" + arr[2]; // 日期补0
          }
          currentDate = arr.join("-"); // 使用"-"连接，返回 YYYY-MM-DD 格式
        } else {
          // 如果日期格式不符合预期，返回空字符串或其他错误标识
          currentDate = null;
        }
        dataList.push(currentDate)
        dataList.push(currentDate)
        return dataList; // 返回当前日期
      },
      getCurrentWeek() {
        const now = new Date();
        const currentDayOfWeek = now.getDay(); // 0 表示周日
        const dayOffset = currentDayOfWeek - 1; // 将周一设为0，周日设为6
        const firstDayOfWeek = new Date(now - dayOffset * 86400000); // 周一的日期
        const lastDayOfWeek = new Date(firstDayOfWeek.getTime() + 6 * 86400000); // 周日的日期
        let dataList = [];
        let rowArr = [
          firstDayOfWeek.toLocaleDateString(),
          lastDayOfWeek.toLocaleDateString(),
        ];
        rowArr.forEach((item) => {
          let arr = item.split("/");
          if (arr[1] < 10) {
            arr[1] = "0" + arr[1];
          }
          if (arr[2] < 10) {
            arr[2] = "0" + arr[2];
          }
          dataList.push(arr.join("-"));
        });
        console.log(dataList)
        return dataList;
      },
      getCurrentMonth() {
        const now = new Date();
        const firstDayOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
        const lastDayOfMonth = new Date(now.getFullYear(), now.getMonth() + 1, 0);
        let dataList = [];
        let rowArr = [
          firstDayOfMonth.toLocaleDateString(),
          lastDayOfMonth.toLocaleDateString(),
        ];
        rowArr.forEach((item) => {
          let arr = item.split("/");
          if (arr[1] < 10) {
            arr[1] = "0" + arr[1];
          }
          if (arr[2] < 10) {
            arr[2] = "0" + arr[2];
          }
          dataList.push(arr.join("-"));
        });
        return dataList;
      },
      getLastSixMonthDate() {
        var tomorrow = new Date();
        tomorrow.setTime(tomorrow.getTime() + 24 * 60 * 60 * 1000);
        var end = tomorrow;
        // 今天的时间
        // var end = new Date()
        var year = end.getFullYear();
        var month = end.getMonth() + 1; // 0-11表示 1-12月
        var day = end.getDate();
        var dateObj = {};
        dateObj.start = null;
        dateObj.end = year + "-" + (month < 10 ? "0" + month : month) + "-" + day;
        var endMonthDay = new Date(year, month, 0).getDate(); // 当前月的总天数
        if (month - 6 <= 0) {
          // 如果是1、2、3、4、5、6月，年数往前推一年
          const start6MonthDay = new Date(
            year - 1,
            12 - (6 - parseInt(month)),
            0
          ).getDate(); // 6个月前所在月的总天数
          if (start6MonthDay < day) {
            // 6个月前所在月的总天数小于现在的天日期
            dateObj.start =
              year -
              1 +
              "-" +
              (12 - (6 - month) < 10 ?
                "0" + (12 - (6 - month)) :
                12 - (6 - month)) +
              "-" +
              start6MonthDay;
          } else {
            dateObj.start =
              year -
              1 +
              "-" +
              (12 - (6 - month) < 10 ?
                "0" + (12 - (6 - month)) :
                12 - (6 - month)) +
              "-" +
              day;
          }
        } else {
          const start6MonthDay = new Date(year, parseInt(month) - 6, 0).getDate(); // 6个月前所在月的总天数
          if (start6MonthDay < day) {
            // 3个月前所在月的总天数小于现在的天日期
            if (day < endMonthDay) {
              // 当前天日期小于当前月总天数,2月份比较特殊的月份
              dateObj.start =
                year +
                "-" +
                (month - 6 < 10 ? "0" + (month - 6) : month - 6) +
                "-" +
                (start6MonthDay - (endMonthDay - day));
            } else {
              dateObj.start =
                year +
                "-" +
                (month - 6 < 10 ? "0" + (month - 6) : month - 6) +
                "-" +
                start6MonthDay;
            }
          } else {
            dateObj.start =
              year +
              "-" +
              (month - 6 < 10 ? "0" + (month - 6) : month - 6) +
              "-" +
              day;
          }
        }
        const newThreeMonthDate = [dateObj.start, dateObj.end];
        return newThreeMonthDate;
      },
      oneYearRange() {
        const start = new Date(new Date());
        start.setFullYear(start.getFullYear() - 1);
        const end = new Date(new Date());
        let dataList = [];
        let rowArr = [start.toLocaleDateString(), end.toLocaleDateString()];
        rowArr.forEach((item) => {
          let arr = item.split("/");
          if (arr[1] < 10) {
            arr[1] = "0" + arr[1];
          }
          dataList.push(arr.join("-"));
        });
        return dataList;
      },
      selectChange(label, index) {
        console.log(this.createTime1X)
        if (index == 0) {
          this.dateData[label] = this.getCurrentDay();
          console.log(' this.dateData[label][0]', this.dateData[label][0])
          this[label + "X"] = this.dateRange(
            this.dateData[label][0],
            this.dateData[label][0]
          );
        } else if (index == 1) {
          this.dateData[label] = this.getCurrentWeek();
          this[label + "X"] = this.dateRange(
            this.dateData[label][0],
            this.dateData[label][1]
          );
        } else if (index == 2) {
          this.dateData[label] = this.getCurrentMonth();
          this[label + "X"] = this.dateRange(
            this.dateData[label][0],
            this.dateData[label][1]
          );
        } else if (index == 3) {
          this.dateData[label] = this.getLastSixMonthDate();
          this[label + "X"] = Array.from(
            new Set(
              this.dateRangeM(this.dateData[label][0], this.dateData[label][1])
            )
          );
        } else if (index == 4) {
          this.dateData[label] = this.oneYearRange();
          this[label + "X"] = Array.from(
            new Set(
              this.dateRangeM(this.dateData[label][0], this.dateData[label][1])
            )
          );
        } else if (index == 5) {
          this.$refs.createTime1.focus();
        }
        if (label == "createTime1") {
          this.SCEoption.xAxis.data = this.createTime1X;
          this.getSCE();
        } else if (label == "createTime2") {
          this.Clickoption.xAxis.data = this.createTime2X;
          this.getClick();
        } else if (label == "createTime3") {
          this.getpay();
        } else if (label == "createTime4") {
          this.SUMoption.xAxis.data = this.createTime4X;
          this.getSUM();
        }
        console.log('this.SCEoption.xAxis.data', this.SCEoption.xAxis.data)

      },
      timeChange(label, index) {
        this.selectData[label] = "5";
        this.dateData[label] = [
          this.datetimeparse(index[0], "YYYY-MM-DD"),
          this.datetimeparse(index[1], "YYYY-MM-DD"),
        ];
        if (this.intervalDays(index[0], index[1]) <= 31) {
          this[label + "X"] = this.dateRange(
            this.dateData[label][0],
            this.dateData[label][1]
          );
        } else if (this.intervalDays(index[0], index[1]) <= 365) {
          this[label + "X"] = Array.from(
            new Set(
              this.dateRangeM(this.dateData[label][0], this.dateData[label][1])
            )
          );
        } else {
          this[label + "X"] = Array.from(
            new Set(
              this.dateRangeY(this.dateData[label][0], this.dateData[label][1])
            )
          );
        }
        if (label == "createTime1") {
          this.SCEoption.xAxis.data = this.createTime1X;
          this.getSCE();
        } else if (label == "createTime2") {
          this.Clickoption.xAxis.data = this.createTime2X;
          this.getClick();
        } else if (label == "createTime3") {
          this.getpay();
        } else if (label == "createTime4") {
          this.SUMoption.xAxis.data = this.createTime4X;
          this.getSUM();
        }
      },
      // 交易总笔数
      getSCE() {
        regUserReport({
          startRq: this.dateData.createTime1[0],
          endRq: this.dateData.createTime1[1],
        }).then((res) => {
          if (res.code == 0) {
            let arr = [];
            this.createTime1X.forEach((item) => {
              console.log(item)
              let arrRow = 0;
              this.createTime1Count = res.data.count;
              res.data.list.forEach((row) => {
                if (row.createTime.includes(item)) {
                  arrRow += row.count;
                }
              });
              arr.push(arrRow);
            });
            this.chart = Chart.init(this.$refs.SCEchart);
            this.SCEoption.series[0].data = arr;
            this.chart.setOption(this.SCEoption);
          }
        });
      },
      // 我用的每日订单金额表
      getSUM() {
        userRefundOrderReport({
          startRq: this.dateData.createTime4[0],
          endRq: this.dateData.createTime4[1],
          token: localStorage.getItem('logintoken')
        }).then((res) => {
          if (res.code == 0) {

            let xArr = [];
            let yArr = [];

            let xArrRefund = [];
            let yArrRefund = [];


            let xArrHKQr = [];
            let yArrHKQr = [];

            let xArrHK = [];
            let yArrHK = [];
            // this.createTime4X.forEach((item) => {
            //   let arrRow = 0;
            //   this.createTime4Count = res.data.count;
            //   res.data.forEach((row) => {
            //     if (row.createTime.includes(item)) {
            //       arrRow += row.dayAmount;
            //     }
            //   });
            //   arr.push(arrRow);
            // });

            //总订单
            res.data.data.forEach((row) => {
              xArr.push(row.createTime);
              yArr.push(row.dayAmount);
            });
            this.totalAmount = res.data.totalAmount;
            this.chart = Chart.init(this.$refs.SUMEchart);
            this.SUMoption.series[0].data = yArr;
            this.SUMoption.xAxis.data = xArr;
            this.chart.setOption(this.SUMoption);

            //退款订单
            res.data.refundData.forEach((row) => {
              xArrRefund.push(row.createTime);
              yArrRefund.push(row.dayAmount);
            });
            this.refundTotalAmount = res.data.refundTotalAmount;
            this.chart = Chart.init(this.$refs.payEchart);
            this.payoption.series[0].data = yArrRefund;
            this.payoption.xAxis.data = xArrRefund;
            this.chart.setOption(this.payoption);

            //香港扫码订单
            res.data.hkQrData.forEach((row) => {
              xArrHKQr.push(row.createTime);
              yArrHKQr.push(row.dayAmount);
            });
            this.hkQrTotalAmount = res.data.hkQrTotalAmount;
            this.chart = Chart.init(this.$refs.showEchart);
            this.payoption.series[0].data = yArrHKQr;
            this.payoption.xAxis.data = xArrHKQr;
            this.chart.setOption(this.payoption);


            //香港订单
            res.data.hkData.forEach((row) => {
              xArrHK.push(row.createTime);
              yArrHK.push(row.dayAmount);
            });
            this.hkTotalAmount = res.data.hkTotalAmount;
            this.chart = Chart.init(this.$refs.showHKEchart);
            this.payoption.series[0].data = yArrHK;
            this.payoption.xAxis.data = xArrHK;
            this.chart.setOption(this.payoption);
          }
        });
      },
      // 总点击量
      getClick() {
        userPayOrderReport({
          startRq: this.dateData.createTime2[0],
          endRq: this.dateData.createTime2[1],
        }).then((res) => {
          if (res.code == 0) {
            let arr = [];
            this.createTime2X.forEach((item) => {
              let arrRow = 0;
              this.createTime2Count = res.data.count;
              res.data.list.forEach((row) => {
                if (row.createTime.includes(item)) {
                  arrRow += row.count;
                }
              });
              arr.push(arrRow);
            });
            this.chart = Chart.init(this.$refs.ClickEchart);
            this.Clickoption.series[0].data = arr;
            this.chart.setOption(this.Clickoption);
          }
        });
      },
      // 支付方式统计
      getpay() {
        vipTypeReport({
          startRq: this.dateData.createTime3[0],
          endRq: this.dateData.createTime3[1],
        }).then((res) => {
          if (res.code == 0) {
            this.createTime3Count = res.data.count;
            let arr = res.data.list.map((item, index) => {
              return {
                value: item.count,
                name: item.title,
                itemStyle: {
                  color: this.colorList[index],
                },
              };
            });
            this.listData = res.data.list;
            this.payoption.series[0].data = arr;
            console.log('套餐', arr)
            this.payoption.legend.data = arr.map((item) => item.name);
            this.chart = Chart.init(this.$refs.payEchart);
            // this.showEhart = Chart.init(this.$refs.showEchart)
            // this.showEhart.setOption(this.payoption)
            this.chart.setOption(this.payoption);
          }
        });
      },
      getVipTypePhoneReport() {
        vipTypePhoneReport()
          .then((res) => {
            // console.log('显示',res.data)
            if (res.code == 0) {
              this.createTime5Count = res.data.count;

              let arr = res.data.list.map((item, index) => {
                return {
                  value: item.count,
                  name: item.title,
                  itemStyle: {
                    color: this.colorList[index],
                  },
                };
              });
              this.showListData = res.data.list;
              this.showUseoption.series[0].data = arr;
              this.showUseoption.legend.data = arr.map((item) => item.name);
              // this.chart = Chart.init(this.$refs.payEchart)
              this.showEhart = Chart.init(this.$refs.showEchart);
              this.showEhart.setOption(this.showUseoption);
              // this.chart.setOption(this.payoption)
            }
          })
          .catch((err) => {
            console.log(err);
          });
      },
      // 支付方式统计
      getpayNum() {
        // this.chart = Chart.init(this.$refs.payNumEchart)
        // this.chart.setOption(this.payNumoption)
      },
    },
  };
</script>
<style>
  .flexItem {
    display: flex;
    justify-content: center;
  }

  .stbox {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    background-color: #f8f8f8;
  }

  .stbgc {
    background-color: #fff;
    height: 60px;
    line-height: 60px;
    border-radius: 5px;
    padding: 0px 16px;
  }

  .stsearch {
    text-align: center;
  }

  .text-c {
    text-align: center;
  }

  .st-gbox {
    background-color: #fff;
    border-radius: 5px;
    height: 40vh;
    box-sizing: border-box;
    padding: 20px;
  }

  .cavasbox {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
  }

  .paybox {
    width: 100%;
    background-color: #fff;
    box-sizing: border-box;
    border-radius: 5px;
    height: 40vh;
  }

  .selectClass {
    border-radius: 14px;
    width: 120px;
  }
</style>



// WEBPACK FOOTER //
// src/views/charts/statistics.vue